import { render, staticRenderFns } from "./EditDisplay.vue?vue&type=template&id=af0ce22e"
import script from "./EditDisplay.vue?vue&type=script&lang=js"
export * from "./EditDisplay.vue?vue&type=script&lang=js"
import style0 from "./EditDisplay.vue?vue&type=style&index=0&id=af0ce22e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports